var React = require('react');

function OpenedIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("rect",{"width":"23","height":"15","x":".5","y":".5","fill":"#F1DEDE","stroke":"#EED3D7","rx":"3","key":0}),React.createElement("polygon",{"fill":"#B94A48","points":"6.707 6 8.475 7.768 7.768 8.475 6 6.707 4.232 8.475 3.525 7.768 5.293 6 3.525 4.232 4.232 3.525 6 5.293 7.768 3.525 8.475 4.232","transform":"translate(6 2)","key":1})]));
}

OpenedIcon.defaultProps = {"width":"24","height":"16","viewBox":"0 0 24 16"};

module.exports = OpenedIcon;

OpenedIcon.default = OpenedIcon;
